var React = require('react');

function HubtpyePointMktg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M91.7425 95.5554L81.5056 21.6336L174.372 93.6767L91.7425 95.5554Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M37.0435 130.113L81.5977 21.5755L91.7894 95.4055L37.0435 130.113Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M37.0469 130.114L91.7543 95.4312L174.375 93.6786L37.0469 130.114Z","fill":"#5915C7","key":2})]);
}

HubtpyePointMktg.defaultProps = {"width":"175","height":"167","viewBox":"0 0 175 167","fill":"none"};

module.exports = HubtpyePointMktg;

HubtpyePointMktg.default = HubtpyePointMktg;
